import type { ExtractPropTypes, PropType } from 'vue'

export const iconProps = {
  prefix: {
    type: String,
    default: 'icon',
  },
  name: {
    type: String,
    required: true,
  },
  size: {
    type: [Number, String] as PropType<string | number>,
    default: 16,
  },
  spin: {
    type: Boolean,
    default: false,
  },
} as const

export type IconProps = ExtractPropTypes<typeof iconProps>
